<template>
<div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h2>Settings</h2>
                </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6" >
            <div class="row justify-content-md-center upload">
                <div class="col-xl-9">
                    <div class="card p-3">
                        <div class="card-header bg-transparent" v-if="isArbs">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h5 class="mb-3">ARBS SETTINGS - {{ arbsType }}</h5>
                                </div>
                            </div>
                        </div>
                        <div class="card-header bg-transparent" v-if="isAutoBidder">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h5 class="mb-3">AUTOBIDDER SETTINGS</h5>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex bd-highlight">
                            <div>
                                <h4 style="color: #0087D4;">USER SETTINGS</h4>
                            </div>
                        </div>
                        <form class="mt-4">
                            <div class="form-row settings">
                                <div v-if="isBidaccumulator" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                        VALID UNTIL TIME
                                    </label>
                                    <select class="form-control cursor-pointer" v-model="validUntilTime">
                                        <option v-for="time in timeArray" :key="time"> {{time}}</option>
                                    </select>
                                </div>
                                <div v-if="isBidaccumulator" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                        FIRM UNTIL TIME
                                    </label>
                                    <select class="form-control cursor-pointer" v-model="firmUntilTime">
                                        <option v-for="time in timeArray" :key="time"> {{time}}</option>
                                    </select>
                                </div>
                                <div v-if="isArbs" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                        FORWARD ALERT TO 
                                    </label>
                                    <multiselect 
                                        v-model="selectedTrader" 
                                        placeholder="Select trader" 
                                        label="firstName" 
                                        track-by="cognitoSub"
                                        :multiple="true" 
                                        :options="traderList"  
                                        :limit="3"  ></multiselect>
                                </div>
                                <div v-if="isArbs" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                         OFFER RESULT PER PAGE COUNT
                                    </label>
                                    <select style="height:45px;border-radius:0" class="form-control cursor-pointer" v-model="pageinationCount">
                                        <option v-for="count in [10,25,50,75,100]" :key="count" :value="count">{{count}}</option>
                                    </select>
                                </div>
                                <div v-if="isArbs" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                         QUANTITY LIMIT (%)
                                    </label>
                                   <input
                                        type="number"
                                        class="form-control"
                                        v-model="quantityLimit"
                                        oninput="javascript: if (this.value > 100) this.value = 100;"
                                        />
                                </div>
                                
                                <!-- <div v-if="isArbs" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                         OFFER LIMIT
                                    </label>
                                   <input
                                        type="number"
                                        class="form-control"
                                        v-model="arbsOfferLimit"
                                       
                                        />
                                </div> -->
                                <div v-if="isAutoBidder" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                        REOFFER SPREAD <span class="hint" data-toggle="tooltip" data-placement="right"  title="Purchased bonds will be reoffered with given spread . In the absence of a specified spread, acquired bonds will not undergo a reoffer process.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i> </span>
                                    </label>
                                   <input
                                        type="number"
                                        class="form-control"
                                        v-model="reOfferSpread"
                                    
                                        />
                                </div>
                                <div v-if="isAutoBidder" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                         BOX TYPE  
                                    </label>
                                    <select class="form-control cursor-pointer" v-model="autoBidderBoxType">
                                        <option v-if="isAutoBidderEnabled" value="BLACK">BLACK</option>
                                        <option value="GREY">GREY</option>
                                    </select>
                                </div>
                                <div v-if="isAutoBidder" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                        SUPPORT DATA DURATION (In Months)  <span class="hint" data-toggle="tooltip" data-placement="right"  title="The system will display the support data history for the specified number of months starting from the current date.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i> </span>
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="supportDataMonths"
                                        />
                                </div>
                                <div v-if="isAutoBidder" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                        BID PRICE IDC TOLLERANCE
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="bidPriceTollerance"
                                        />
                                </div>
                                <div v-if="isAutoBidder" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                        BID BY YIELD SPREAD
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="bidByYieldSpread"
                                        />
                                </div>
                                <div v-if="isAutoBidder" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                        TRADING ACCOUNT IBP 
                                    </label>
                                    <select style="height:45px;border-radius:0" class="form-control cursor-pointer" v-model="autoBidderHoldingAccountIBP">
                                        <option v-for="account in bpAccountList" :key="account.id" :value="account.id">{{account.account}}</option>
                                    </select>
                                </div>
                                <div v-if="isAutoBidder" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                        TRADING ACCOUNT TMC 
                                    </label>
                                    <select style="height:45px;border-radius:0" class="form-control cursor-pointer" v-model="autoBidderHoldingAccountTMC">
                                        <option v-for="account in tmcAccountList" :key="account.id" :value="account.id">{{account.account}}</option>
                                    </select>
                                </div>
                                <div v-if="isAutoBidder" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                        TRADING ACCOUNT TWD
                                    </label>
                                    <select style="height:45px;border-radius:0" class="form-control cursor-pointer" v-model="autoBidderHoldingAccountTWD">
                                        <option v-for="account in twAccountList" :key="account.id" :value="account.id">{{account.account}}</option>
                                    </select>
                                </div>
                                <div v-if="isAutoBidder" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                        MAXIMUM QUANTITY
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="maxQuantity"
                                        />
                                </div>
                                <div v-if="isAutoBidder" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                        AUTOBIDDER ECN
                                    </label>
                                    <multiselect 
                                        :disabled="!isAutoBidderEnabled"
                                        v-model="ecns" 
                                        placeholder="Ecn" 
                                        :options="ecnListAutoBidder" 
                                        :multiple="true" 
                                        :showLabels="false"
                                        :limit="4"  >
                                    </multiselect>
                                </div>
                                <div v-if="isAutoBidder" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                        MAXIMUM BIDS PER DAY
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="maxBids"
                                        />
                                </div>
                                <div v-if="isAutoBidder" class="form-group col-md-6 text-uppercase">
                                    <label for="inputEmail4">
                                        BA BIDS HISTORY(DAYS)
                                        <span class="hint" data-toggle="tooltip" data-placement="right"  title="The system will show bids received for the specified number of days. If not configured, the available bids for the current day will be presented.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i> </span>
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="bidAccumulatorBidsHistoryDays"
                                        />
                                </div>
                                <div v-if="isAutoBidder" class="form-group col-md-6 text-uppercase">
                                    <label for="inputEmail4">
                                        Bid for Existing Positions
                                    </label>
                                    <toggle-button class="ml-2" :sync="true" v-model="bidAccumulatorBidForExistingPosition"/>
                                </div>
                                <div v-if="isAutoBidder" class="form-group col-md-6 text-uppercase">
                                    <label for="inputEmail4">
                                         Manual Rerun
                                    </label>
                                    <toggle-button class="ml-2" :sync="true" v-model="enableManualRerun"/>
                                </div>
                            </div>
                        </form>
                        <div class="d-flex bd-highlight" v-if="!isAutoBidder">
                            <div>
                                <h4 style="color: #0087D4;">GLOBAL SETTINGS</h4>
                            </div>
                        </div>
                        <form class="mt-4">
                            <div class="form-row settings">
                                <div v-if="isArbs" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                         HOLDING ACCOUNT
                                    </label>
                                    <select style="height:45px;border-radius:0" class="form-control cursor-pointer" v-model="accountId">
                                        <option v-for="account in accountList" :key="account.accountMappingId" :value="account.accountMappingId">{{account.account}}</option>
                                    </select>
                                </div>
                                <div v-if="isArbs" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                         FEED MINIMUM RATING
                                    </label>
                                    <select  class="form-control" id="exampleFormControlSelect1"  v-model="arbsFeedMinimumRating">
                                        <option value>Please select</option>
                                        <option
                                        v-for="sp in spRatingConstants"
                                        :key="sp"
                                        v-bind:value="sp"
                                        
                                    >{{sp}}</option>
                                    </select>
                                </div>
                                <div v-if="isArbs" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                         FEED MINIMUM SOURCE QTY
                                    </label>
                                   <input
                                        type="number"
                                        class="form-control"
                                        v-model="arbsFeedMinQtySend"
                                       
                                        />
                                </div>
                                <div v-if="isArbs" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                         MAXIMUM QTY TO SEND
                                    </label>
                                   <input
                                        type="number"
                                        class="form-control"
                                        v-model="arbsFeedMaxQtySend"
                                       
                                        />
                                </div>
                                <!-- <div v-if="isArbs" class="form-group col-md-6">
                                    <label for="inputEmail4">
                                         FEED QUANTITY LIMIT (%)
                                    </label>
                                   <input
                                        type="number"
                                        class="form-control"
                                        v-model="arbsFeedQtyLimit"
                                        oninput="javascript: if (this.value > 100) this.value = 100;"
                                        />
                                </div> -->
                                <div v-if="isArbs" class="form-group col-md-4">
                                    <label for="inputEmail4">
                                         FEED QUANTITY LIMIT FROM  (%) 
                                    </label>
                                   <input
                                        type="number"
                                        class="form-control"
                                        v-model="arbsFeedQtyLimitFrom"
                                        oninput="javascript: if (this.value > 100) this.value = 100;"
                                        />
                                </div>
                                <div v-if="isArbs" class="form-group col-md-4">
                                    <label for="inputEmail4">
                                         FEED QUANTITY LIMIT TO  (%)
                                    </label>
                                   <input
                                        type="number"
                                        class="form-control"
                                        v-model="arbsFeedQtyLimitTo"
                                        oninput="javascript: if (this.value > 100) this.value = 100;"
                                        />
                                </div>
                                <div v-if="isArbs" class="form-group col-md-4">
                                    <label for="inputEmail4">
                                         FEED QUANTITY INCREMENT  (%)
                                    </label>
                                   <input
                                        type="number"
                                        class="form-control"
                                        v-model="arbsFeedQtyLimitIncrement"
                                        oninput="javascript: if (this.value > 100) this.value = 100;"
                                        />
                                </div>
                                <div v-if="isArbs" class="form-group col-md-4">
                                    <label for="inputEmail4">
                                         OFFER LIMIT
                                    </label>
                                   <input
                                        type="number"
                                        class="form-control"
                                        v-model="arbsOfferLimit"
                                       
                                        />
                                </div>
                                <div v-if="isArbs" class="form-group col-md-4">
                                    <label for="inputEmail4">
                                         FEED MINIMUM YTW
                                    </label>
                                   <input
                                        type="number"
                                        class="form-control"
                                        v-model="arbsFeedMinimumYTW"
                                       
                                        />
                                </div>
                                <div v-if="isArbs" class="form-group col-md-4">
                                    <label for="inputEmail4">
                                        RESTRICT UPLOAD TO
                                    </label>
                                    <multiselect 
                                        v-model="arbsFeedRestriction" 
                                        placeholder="Ecn" 
                                        :options="ecnList" 
                                        :multiple="true" 
                                        :showLabels="false"
                                        :limit="4"  >
                                    </multiselect>
                                </div>
                                <div v-if="isArbs" class="form-group col-md-4">
                                    <label for="inputEmail4">
                                        SPREAD RANGE FROM
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="spreadRangeFrom"
                                        />
                                </div>
                                <div v-if="isArbs" class="form-group col-md-4">
                                    <label for="inputEmail4">
                                        SPREAD RANGE TO
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="spreadRangeTo"
                                        />
                                </div>
                                <div v-if="isArbs" class="form-group col-md-4">
                                    <label for="inputEmail4">
                                        SPREAD INCREMENT
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="spreadIncrement"
                                        />
                                </div>
                                <div v-if="isArbs" class="form-group col-md-4">
                                    <label for="inputEmail4">
                                        FEED SAFETY NET PRICE THRESHOLD
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="feedSafetyNetPriceThreshold"
                                        />
                                </div>
                                <div v-if="isArbs" class="form-group col-md-4">
                                    <label for="inputEmail4">
                                        FEED SAFETY NET DURATION(MINUTES)
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="feedSafetyNetDuration"
                                        />
                                </div>
                                <div v-if="isArbs" class="form-group col-md-4">
                                    <label for="inputEmail4">
                                        ARBS FEED MINIMUM INCREMENT FROM
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="arbsFeedMinIncrFrom"
                                        @change="changedArbsFeedRestriction = true"
                                        />
                                </div>
                                <div v-if="isArbs" class="form-group col-md-4">
                                    <label for="inputEmail4">
                                        ARBS FEED MINIMUM INCREMENT TO
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="arbsFeedMinIncrTo"
                                        @change="changedArbsFeedRestriction = true"
                                        />
                                </div>
                                <div v-if="isArbs" class="form-group col-md-4">
                                    <label for="inputEmail4">
                                        ARBS FEED MINIMUM BALANCE REMAINING FROM
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="arbsFeedMinBalRemFrom"
                                        @change="changedArbsFeedRestriction = true"
                                        />
                                </div>
                                <div v-if="isArbs" class="form-group col-md-4">
                                    <label for="inputEmail4">
                                        ARBS FEED MINIMUM BALANCE REMAINING TO
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="arbsFeedMinBalRemTo"
                                        @change="changedArbsFeedRestriction = true"
                                        />
                                </div>
                               
                                
                            </div>
                            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                            <!-- <span class="text-warning" v-if="showWarningMessage && isAutoBidder">{{ warningMessage }}</span> -->
                            <div class="form-group col-md-12 text-center">
                                <button @click="checkBeforeSave()" type="button" class="btn btn-success">SAVE</button>
                            </div>
                        </form>        
                    </div>
                </div>
            </div>
        </div>
    </div>        
</template>
<script>
import config from "@/config";
import authService from "@/authService";

import spRatingConstants from "@/spRatingConstants";

export default {
  name: "basetting",
  components: {
    
  },
  data() {
    return {
        loading : false,
        userSettings : null,
        validUntilTime : "",
        firmUntilTime : "",
        arbsSpread : "",
        timeArray : [],
        traderList : [],
        selectedTrader : [],
        isBidaccumulator : window.location.href.includes("bidaccumulator"),
        isArbs : window.location.href.includes("ims"),
        isAutoBidder : window.location.href.includes("autobidder"),
        accountId : null,
        accountList : [],
        pageinationCount : 0,
        quantityLimit : null,
        reOfferSpread : null,
        bidQuantityRange : 0,
        arbsFeedQtyLimitFrom : 0,
        arbsFeedQtyLimitTo : 0,
        arbsOfferLimit : 0,
        autoBidderHoldingAccountIBP : null,
        autoBidderHoldingAccountTMC : null,
        autoBidderHoldingAccountTWD : null,
        autoBidderBoxType : null,
        supportDataFromDate : "",
        arbsFeedMinimumRating : "",
        spRatingConstants:spRatingConstants,
        arbsFeedMinQtySend : null,
        arbsFeedMaxQtySend : null,
        ecnList : [ 'TWD','IBP','TMC','MKTX'],
        ecnListAutoBidder : [ 'TWD','IBP','TMC'],
        ecns : [],
        bidPriceTollerance : null,
        tmcAccountList : [],
        bpAccountList : [],
        twAccountList : [],
        bidByYieldSpread : "",
        maxQuantity : "",
        isAutoBidderEnabled : false,
        showWarningMessage : false,
        maxBids : null,
        supportDataMonths : null,
        bidAccumulatorBidsHistoryDays : null,
        arbsFeedMinimumYTW : null,
        bidAccumulatorBidForExistingPosition : true,
        arbsFeedRestriction : [],
        savedArbsFeedRestriction : [],
        enableManualRerun : false,
        spreadRangeFrom : null,
        spreadRangeTo : null,
        spreadIncrement : null,
        arbsFeedQtyLimitIncrement : null,
        feedSafetyNetPriceThreshold : "",
        feedSafetyNetDuration : "",
        arbsFeedMinIncrFrom : null,
        arbsFeedMinIncrTo : null,
        arbsFeedMinBalRemFrom : null,
        arbsFeedMinBalRemTo : null,
        changedArbsFeedRestriction : false,
        arbsType : window.location.href.includes("corps") ? "CORPS" : "MUNIS"
    };
  },
  methods: {
    getUser(){
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user?cognitoSub="+
            authService.getUser().cognitoSub,
            auth
        )
        .then(result => {
          this.isAutoBidderEnabled = result.data.blackBoxEnabled
        })
    },
    checkArrayEqual(){
        let array1 = this.savedArbsFeedRestriction;
        let array2 = this.arbsFeedRestriction

        if (array1.length !== array2.length) {
            return false
        } else {
            let unequal = false;
            for (let i = 0; i < array1.length; i++) {
                if (array1[i] !== array2[i]) {
                    unequal = true;
                    break;
                }
            }
            if (unequal) {
                return false

            } else {
                return true

            }
        }
    },
    checkBeforeSave(){
        if(!this.checkArrayEqual()){
            var message = `You are about to change the arbs feed sending restrictions. Any previously sent arbs offers on this day must be suspended before doing this.`;
            this.$confirm(message,"Are you sure to proceed?","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
                this.saveSettings()
            })
        }else{
            if (this.spreadRangeFrom !== null && this.spreadRangeTo !== null && this.spreadIncrement !== null){
                const difference = this.spreadRangeTo - this.spreadRangeFrom;
                if (this.spreadIncrement >= difference) {
                    this.$alert("Spread Increment must be less than the difference between Spread Range From and Spread Range To.","","error")
                }else{
                    this.saveSettings();
                }

            }else{
                if(this.changedArbsFeedRestriction){
                    var message2 = `You are about to change the min-incr/min-bal-rem setting. Any previously sent arbs offers on this day must be suspended before doing this.`;
                    this.$confirm(message2,"Are you sure to proceed?","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
                        this.saveSettings()
                    })
                }else{
                    this.saveSettings();
                }
            }


        }
    },
    saveSettings(){
        if (this.arbsFeedQtyLimitFrom !== null && this.arbsFeedQtyLimitTo !== null && this.arbsFeedQtyLimitIncrement !== null){
            const difference = this.arbsFeedQtyLimitTo - this.arbsFeedQtyLimitFrom;
            if (this.arbsFeedQtyLimitIncrement >= difference) {
                this.$alert("Feed quantity increment must be less than the difference between feed quantity limit from and feed quantity limit to.","","error");
                return false
            }
        }

        let dataToSend = [
                            {
                                "setting": "BW_FIRM_UNTILL_TIME",
                                "dataType": "TIME",
                                "value": this.firmUntilTime,
                                "cognitoSub": authService.getUser().cognitoSub
                            },
                            {
                                "setting": "BW_VALID_UNTILL_TIME",
                                "dataType": "TIME",
                                "value": this.validUntilTime,
                                "cognitoSub": authService.getUser().cognitoSub
                            },
                             {
                                "setting": "PAGINATION_COUNT",
                                "dataType": "NUMERIC",
                                "value": this.pageinationCount,
                                "cognitoSub": authService.getUser().cognitoSub
                            },
                            {
                                "setting": "FORWARD_ALERT_USER",
                                "dataType": "STRING",
                                "value": this.selectedTrader.map(trader => trader.cognitoSub).toString(),
                                "cognitoSub": authService.getUser().cognitoSub
                            },
                            {
                                "setting": "ARBS_ACCOUNT",
                                "dataType": "NUMERIC",
                                "value": this.accountId,
                            },
                            {
                                "setting": "ARBS_QTY_LIMIT",
                                "dataType": "NUMERIC",
                                "value": this.quantityLimit,
                                "cognitoSub": authService.getUser().cognitoSub
                            },
                            {
                                "setting": "AUTOBIDDER_REOFFER_SPREAD",
                                "dataType": "NUMERIC",
                                "value": this.reOfferSpread,
                                "cognitoSub": authService.getUser().cognitoSub
                            },
                            {
                                "setting": "ARBS_FEED_QTY_LIMIT_FROM",
                                "dataType": "NUMERIC",
                                "value": this.arbsFeedQtyLimitFrom,
                                // "cognitoSub": authService.getUser().cognitoSub
                            },
                            {
                                "setting": "ARBS_FEED_QTY_LIMIT_TO",
                                "dataType": "NUMERIC",
                                "value": this.arbsFeedQtyLimitTo,
                                // "cognitoSub": authService.getUser().cognitoSub
                            },
                            {
                                "setting": "ARBS_OFFER_LIMIT",
                                "dataType": "NUMERIC",
                                "value": this.arbsOfferLimit,
                                //"cognitoSub": authService.getUser().cognitoSub
                            },
                            {
                                "setting": "AUTOBIDDER_IBP_ACCOUNT",
                                "dataType": "NUMERIC",
                                "value": this.autoBidderHoldingAccountIBP,
                                "cognitoSub": authService.getUser().cognitoSub
                                
                            },
                            {
                                "setting": "AUTOBIDDER_TMC_ACCOUNT",
                                "dataType": "NUMERIC",
                                "value": this.autoBidderHoldingAccountTMC,
                                "cognitoSub": authService.getUser().cognitoSub
                                
                            },
                            {
                                "setting": "AUTOBIDDER_TWD_ACCOUNT",
                                "dataType": "NUMERIC",
                                "value": this.autoBidderHoldingAccountTWD,
                                "cognitoSub": authService.getUser().cognitoSub
                                
                            },
                            {
                                "setting": "AUTOBIDDER_BOX_TYPE",
                                "dataType": "STRING",
                                "value": this.autoBidderBoxType,
                                "cognitoSub": authService.getUser().cognitoSub
                            },
                            {
                                "setting": "SUPPORT_DATA_BACK_MONTH",
                                "dataType": "NUMERIC",
                                "value": this.supportDataMonths,
                                "cognitoSub": authService.getUser().cognitoSub
                            },
                            {
                                "setting": "ARBS_FEED_MINIMUM_RATING",
                                "dataType": "STRING",
                                "value": this.arbsFeedMinimumRating
                            },
                            {
                                "setting": "ARBS_FEED_MINIMUM_QTY_TO_SEND",
                                "dataType": "NUMERIC",
                                "value": this.arbsFeedMinQtySend,
                                
                            },
                            {
                                "setting": "ARBS_MAXIMUM_QTY_TO_SEND",
                                "dataType": "NUMERIC",
                                "value": this.arbsFeedMaxQtySend,
                            },
                            {
                                "setting": "BID_PRICE_CHECK_FACTOR",
                                "dataType": "NUMERIC",
                                "value": this.bidPriceTollerance,
                                "cognitoSub": authService.getUser().cognitoSub

                            },
                            {
                                "setting": "BID_BY_YIELD_SPREAD",
                                "dataType": "NUMERIC",
                                "value": this.bidByYieldSpread,
                                "cognitoSub": authService.getUser().cognitoSub

                            },
                            {
                                "setting": "AUTOBIDDER_MAX_QTY",
                                "dataType": "NUMERIC",
                                "value": this.maxQuantity,
                                "cognitoSub": authService.getUser().cognitoSub
                            },
                            {
                                "setting": "AUTOBIDDER_MAX_BIDS",
                                "dataType": "NUMERIC",
                                "value": this.maxBids,
                                "cognitoSub": authService.getUser().cognitoSub
                            },
                            {
                                "setting": "DAY_RANGE_FOR_BW_AVAILABLE",
                                "dataType": "STRING",
                                "value": this.bidAccumulatorBidsHistoryDays,
                                "cognitoSub": authService.getUser().cognitoSub
                            },                           
                            {
                                "setting": "ARBS_FEED_MINIMUM_YTW",
                                "dataType": "NUMERIC",
                                "value": this.arbsFeedMinimumYTW
                            },
                            {
                                "setting": "INVENTORY_HOLDING_FETCH_ENABLED",
                                "dataType": "STRING",
                                "cognitoSub": authService.getUser().cognitoSub,
                                "value": this.bidAccumulatorBidForExistingPosition ? "TRUE" : "FALSE"
                            },
                            {
                                "setting": "ARBS_FEED_SENDING_RESTRICTION",
                                "dataType": "LIST_STRING",
                                "value": this.arbsFeedRestriction.toString()
                            },
                            {
                                "setting": "ENABLE_MANUAL_BID_RERUN",
                                "dataType": "STRING",
                                "cognitoSub": authService.getUser().cognitoSub,
                                "value": this.enableManualRerun ? "TRUE" : "FALSE"
                            },
                            {
                                "setting": "ARBS_FEED_SPREAD_FROM",
                                "dataType": "NUMERIC",
                                "value": this.spreadRangeFrom
                            },
                            {
                                "setting": "ARBS_FEED_SPREAD_TO",
                                "dataType": "NUMERIC",
                                "value": this.spreadRangeTo
                            },
                            {
                                "setting": "ARBS_FEED_SPREAD_INCREMENT",
                                "dataType": "NUMERIC",
                                "value": this.spreadIncrement
                            },
                            {
                                "setting": "ARBS_FEED_QTY_LIMIT_INCREMENT",
                                "dataType": "NUMERIC",
                                "value": this.arbsFeedQtyLimitIncrement
                            },
                            {
                                "setting": "ARBS_FEED_SAFETY_NET_PRICE_THRESHOLD",
                                "dataType": "NUMERIC",
                                "value": this.feedSafetyNetPriceThreshold
                            },
                            {
                                "setting": "ARBS_FEED_SAFETY_NET_DURATION_MINUTES",
                                "dataType": "NUMERIC",
                                "value": this.feedSafetyNetDuration
                            },
                            {
                                "setting": "ARBS_FEED_MIN_INCR_FROM",
                                "dataType": "NUMERIC",
                                "value": this.arbsFeedMinIncrFrom
                            },
                            {
                                "setting": "ARBS_FEED_MIN_INCR_TO",
                                "dataType": "NUMERIC",
                                "value": this.arbsFeedMinIncrTo
                            },
                            {
                                "setting": "ARBS_FEED_MIN_BAL_REM_FROM",
                                "dataType": "NUMERIC",
                                "value": this.arbsFeedMinBalRemFrom
                            },
                            {
                                "setting": "ARBS_FEED_MIN_BAL_REM_TO",
                                "dataType": "NUMERIC",
                                "value": this.arbsFeedMinBalRemTo
                            }
                            
                            
                            
                        ]
        this.loading = true;
        this.showWarningMessage = false;
        console.log(this.reOfferSpread)
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .post(
            config.baseUrlBidSide +
                "/tradebook/setting",dataToSend,
                auth
            )
            .then(() => {
                this.loading = false;
                this.$alert("Saved successfully ","","success")
                this.getUserSetting()

                if(this.reOfferSpread === null || this.reOfferSpread === ""){
                    this.showWarningMessage = true;
                    this.warningMessage = "Purchased bonds will be reoffered at the same price.";
                    return false
                }
                if(Number(this.reOfferSpread) === 0){
                    this.showWarningMessage = true;
                    this.warningMessage = "Purchased bonds will not be reoffered.";
                }
                this.changedArbsFeedRestriction = false;
                

            })
            .catch(e => {
                console.log(e);
            });

        if(this.isAutoBidder){
            this.setBlackBoxEcn()
        }
    },
    getUserSetting(){
        this.loading = true;
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide +
                "/tradebook/setting-list?cognitoSub="+authService.getUser().cognitoSub,
                auth
            )
            .then(result => {
                this.userSettings = result.data;
                this.userSettings.forEach(element => {
                    if(element.setting == "BW_FIRM_UNTILL_TIME"){
                        this.firmUntilTime = element.value
                    }
                    if(element.setting == "BW_VALID_UNTILL_TIME"){
                        this.validUntilTime = element.value
                    }
                    if(element.setting == "ARBS_SPREAD"){
                        this.arbsSpread = element.value
                    }
                    if(element.setting == "ARBS_ACCOUNT" && element.cognitoSub == null){
                        this.accountId = element.value
                    }
                    if(element.setting == "PAGINATION_COUNT"){
                        this.pageinationCount = element.value
                    }
                    if(element.setting == "ARBS_QTY_LIMIT"){
                        this.quantityLimit = element.value
                    }
                    if(element.setting == "FORWARD_ALERT_USER"){
                        this.selectedTrader = [];
                        let savedForwardTrader = element.value.split(',');
                        
                        savedForwardTrader.forEach((cognitoSub) => {
                            let trader = this.traderList.find((trader) => trader.cognitoSub == cognitoSub);
                            if(trader)  this.selectedTrader.push(trader)
                        }) 

                        // this.traderList.forEach((trader) => {
                        //     if(trader.cognitoSub == element.value) this.selectedTrader = trader;
                        // })                        
                    }
                    if(element.setting == "AUTOBIDDER_REOFFER_SPREAD"){
                        this.reOfferSpread = element.value
                    }
                    if(element.setting == "ARBS_FEED_QTY_LIMIT_FROM"){
                        this.arbsFeedQtyLimitFrom = element.value
                    }
                    if(element.setting == "ARBS_FEED_QTY_LIMIT_TO"){
                        this.arbsFeedQtyLimitTo = element.value
                    }
                    if(element.setting == "ARBS_OFFER_LIMIT"){
                        this.arbsOfferLimit = element.value
                    }
                    if(element.setting == "AUTOBIDDER_IBP_ACCOUNT"){
                        this.autoBidderHoldingAccountIBP = element.value
                    }
                    if(element.setting == "AUTOBIDDER_TMC_ACCOUNT"){
                        this.autoBidderHoldingAccountTMC = element.value
                    }
                    if(element.setting == "AUTOBIDDER_TWD_ACCOUNT"){
                        this.autoBidderHoldingAccountTWD = element.value
                    }
                    if(element.setting == "AUTOBIDDER_BOX_TYPE"){
                        this.autoBidderBoxType = element.value
                    }
                    if(element.setting == "SUPPORT_DATA_BACK_MONTH"){
                        this.supportDataMonths = element.value
                    }
                    if(element.setting == "ARBS_FEED_MINIMUM_RATING"){
                        this.arbsFeedMinimumRating = element.value
                    }
                    if(element.setting == "ARBS_FEED_MINIMUM_QTY_TO_SEND"){
                        this.arbsFeedMinQtySend = element.value
                    }
                    if(element.setting == "ARBS_MAXIMUM_QTY_TO_SEND"){
                        this.arbsFeedMaxQtySend = element.value
                    }
                    if(element.setting == "BID_PRICE_CHECK_FACTOR"){
                        this.bidPriceTollerance = element.value
                    }
                    if(element.setting == "BID_BY_YIELD_SPREAD"){
                        this.bidByYieldSpread = element.value
                    }
                    if(element.setting == "AUTOBIDDER_MAX_QTY"){
                        this.maxQuantity = element.value
                    }
                    if(element.setting == "AUTOBIDDER_MAX_BIDS"){
                        this.maxBids = element.value
                    }
                    if(element.setting == "DAY_RANGE_FOR_BW_AVAILABLE"){
                        this.bidAccumulatorBidsHistoryDays = element.value
                    }
                    if(element.setting == "ARBS_FEED_MINIMUM_YTW"){
                        this.arbsFeedMinimumYTW = element.value
                    }
                    if(element.setting == "INVENTORY_HOLDING_FETCH_ENABLED"){
                        this.bidAccumulatorBidForExistingPosition = element.value == 'TRUE' ? true : false
                    }
                    if(element.setting == "ARBS_FEED_SENDING_RESTRICTION"){
                        this.savedArbsFeedRestriction  = element.value ? element.value.split(',') : []
                        this.arbsFeedRestriction =  element.value ? element.value.split(',') : []
                    }
                    if(element.setting == "ENABLE_MANUAL_BID_RERUN"){
                        this.enableManualRerun = element.value == 'TRUE' ? true : false
                    }
                    if(element.setting == "ARBS_FEED_SPREAD_FROM"){
                        this.spreadRangeFrom = element.value
                    }
                    if(element.setting == "ARBS_FEED_SPREAD_TO"){
                        this.spreadRangeTo = element.value
                    }
                    if(element.setting == "ARBS_FEED_SPREAD_INCREMENT"){
                        this.spreadIncrement = element.value
                    }
                    if(element.setting == "ARBS_FEED_QTY_LIMIT_INCREMENT"){
                        this.arbsFeedQtyLimitIncrement = element.value
                    }
                    if(element.setting == "ARBS_FEED_SAFETY_NET_PRICE_THRESHOLD"){
                        this.feedSafetyNetPriceThreshold = element.value
                    }
                    if(element.setting == "ARBS_FEED_SAFETY_NET_DURATION_MINUTES"){
                        this.feedSafetyNetDuration = element.value
                    }
                    if(element.setting == "ARBS_FEED_MIN_INCR_FROM"){
                        this.arbsFeedMinIncrFrom = element.value
                    }
                    if(element.setting == "ARBS_FEED_MIN_INCR_TO"){
                        this.arbsFeedMinIncrTo = element.value
                    }
                    if(element.setting == "ARBS_FEED_MIN_BAL_REM_FROM"){
                        this.arbsFeedMinBalRemFrom = element.value
                    }
                    if(element.setting == "ARBS_FEED_MIN_BAL_REM_TO"){
                        this.arbsFeedMinBalRemTo = element.value
                    }

                    
                });
                this.loading = false;
            })
            .catch(e => {
                console.log(e);
            });
    },
    getTraderList(){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Drl-Trader",
            auth
        )
        .then(result => {
          // this.traderList = result.data.content.filter((e) => {return e.traderId != null});
          result.data.content.forEach(trader =>{
            trader.firstName =  trader.firstName+" "+trader.lastName;
          });
          this.traderList = result.data.content.filter((e) => {return e.cognitoSub != authService.getUser().cognitoSub});
          this.getUserSetting();
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getAccountList(){
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide +
                "/account/customer-account",
                auth
            )
            .then(result => {
                this.accountList = result.data;
            })
            .catch(e => {
                console.log(e);
            });
    },
    setBlackBoxEcn(){
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .put(
            config.baseUrlAutoBidder +
                "/autobidder/set-blackbox-ecn",{"ecns":this.ecns,"cognito":authService.getUser().cognitoSub},
                auth
            )
            .then(() => {
                
            })
            .catch(e => {
                console.log(e);
            });
    },
    getBlackBoxEcn(){
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlAutoBidder +
                "/autobidder/get-blackbox-ecn?cognito="+authService.getUser().cognitoSub,
                auth
            )
            .then(result => {
                this.ecns = result.data;
            })
            .catch(e => {
                console.log(e);
            });
    },
    getAccountListAutoBidder(){
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide + "/account/list?ecn=IBP,TMC,TWD",
          auth
        )
        .then(response => {
            this.bpAccountList = response.data.filter((item) => {
                return item.ecn == 'IBP' && item.accountValue != 'SMU0000042'
            });
            this.tmcAccountList = response.data.filter((item) => {
                return item.ecn == 'TMC'
            });
            this.twAccountList = response.data.filter((item) => {
                return item.ecn == 'TWD'
            });
        // this.getSettings()

        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    }
  },
  mounted() {
    this.getUser();
    this.getTraderList();
    this.getAccountList();
    if(this.isAutoBidder){
        this.getAccountListAutoBidder();
        this.getBlackBoxEcn();
    }


    for (let indexHOUR = 9; indexHOUR < 17; indexHOUR++) {
        for (let indexMIN = 0; indexMIN < 4; indexMIN++) {
            let minute = ["00","15","30","45"]
            this.timeArray.push((indexHOUR > 12 ? indexHOUR -12 : indexHOUR) +":"+minute[indexMIN])
        }
    }
  }
};
</script>